export default {
  title: 'Ajouter un partenaire',
  mode: {
    single: 'Partenaire unique',
    bulk: 'En masse (CSV)',
  },
  buttons: {
    send_invite: "Envoyer l'invitation",
  },
  bulk: {
    form: {
      file: {
        label: 'Liste de partenaires (CSV)',
        hint: "Un partenaire par ligne. Colonnes requises : E-mail, Pays de l'entreprise, et Raison sociale ou Nom de l'entreprise. Le nom de marque est facultatif et devient le nom affiché aux consommateurs. Chaque ligne est validée avant toute création.",
      },
    },
    buttons: {
      select_file: 'Sélectionner un fichier CSV',
      download_template: "Télécharger le modèle d'importation",
      import: 'Importer des partenaires',
    },
    columns: {
      legal_name: "Raison sociale / Nom de l'entreprise",
      display_name: 'Nom de marque',
      admin_email: 'E-mail',
      company_country: "Pays de l'entreprise",
    },
    errors: {
      title: "Le fichier n'a pas pu être importé.",
      nothing_imported:
        "Aucun partenaire n'a été créé. Corrigez les lignes ci-dessus et importez à nouveau le fichier.",
      columns: {
        row: 'Ligne',
        column: 'Colonne',
        error: 'Erreur',
      },
    },
    toasts: {
      queued_one:
        "{{count}} partenaire en file d'attente — les invitations sont envoyées au fur et à mesure de la création. Vous recevrez un e-mail récapitulatif à la fin de l'importation.",
      queued_other:
        "{{count}} partenaires en file d'attente — les invitations sont envoyées au fur et à mesure de la création. Vous recevrez un e-mail récapitulatif à la fin de l'importation.",
    },
    footnote:
      "Les partenaires sont créés un par un en arrière-plan avec la même configuration qu'un partenaire unique : e-mail d'invitation, sous-domaine du tableau de bord et domaine de boutique par défaut. Le pays détermine la devise et le fuseau horaire ; un état peut être défini plus tard depuis le profil du partenaire. Le traitement des paiements est configuré ensuite dans l'onglet Paiements de chaque partenaire.",
  },
  form: {
    name: {
      label: 'Nom du partenaire',
    },
    admin_email: {
      label: "E-mail admin (destinataire de l'invitation)",
      hint: 'Nous leur enverrons une invitation par e-mail pour créer leur compte.',
    },
    display_name: {
      label: 'Nom affiché aux clients',
      hint: 'Le libellé « Propulsé par ___ » affiché aux clients. Par défaut, le nom du partenaire si laissé vide.',
    },
    region: {
      label: 'Pays',
      placeholder: 'Sélectionner un pays',
      hint: "Définit la devise, le fuseau horaire et la langue d'invitation du partenaire.",
      summary: "Devise {{currency}} · {{timezone}} · Langue d'invitation {{language}}",
      default_root: 'Domaine de la boutique : les nouvelles marques sont servies sur {{host}}',
    },
    sub_region: {
      label: 'État',
      placeholder: 'Tout le pays',
      hint: 'Facultatif — laisser vide pour appliquer à tout le pays.',
    },
    language: {
      label: "Langue d'invitation",
      placeholder: '{{language}} (par défaut)',
      hint: 'Facultatif — par défaut, la langue principale du pays.',
    },
  },
  footnote: "Les paramètres de marque et de revenus pourront être configurés après l'acceptation de l'invitation.",
  toasts: {
    created: "Partenaire créé — l'e-mail d'invitation est en cours d'envoi.",
  },
};
